import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const DownArrowIcon: React.FC<NormalIconProps> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" className={props.className} onClick={props.onClick} width="25" height="25" viewBox="0 0 4 3.388">
		<path d="M1.623,3.263c-.019-.019-.1-.091-.17-.159A7.358,7.358,0,0,1,.112,1.141,1.609,1.609,0,0,1,0,.741a.667.667,0,0,1,.073-.3.629.629,0,0,1,.3-.269A3.263,3.263,0,0,1,.729.081,7.879,7.879,0,0,1,2,0,9.1,9.1,0,0,1,3.227.072,2.753,2.753,0,0,1,3.67.188.6.6,0,0,1,4,.722V.741a1.677,1.677,0,0,1-.136.448,7.348,7.348,0,0,1-1.322,1.92,1.9,1.9,0,0,1-.185.164A.589.589,0,0,1,2,3.388a.619.619,0,0,1-.379-.125" />
	</svg>
);
